module.exports = __webpack_public_path__ + "img/1584500584.80bfb69b.jpg";